import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import usePDPStore, { useActiveProductData, useActiveConfigurationSKU } from "@store/pdp";
import { log } from "@assets/js/utils";
import "./pdp-current-configuration-info.scss";

const PDPCurrentConfigurationInfo = () => {
    const [activeProductData] = useActiveProductData();
    const activeProductHeroDisplayName = usePDPStore((state) => state.activeProductHeroDisplayName);
    const [activeConfigurationSKU] = useActiveConfigurationSKU();
    const { t } = useTranslation();

    const texts = {
        model: t(
            "FritzHansen_Project_ConsumersAndProfessionals_PDP_Model"
        ),
        currentSelection: t(
            "FritzHansen_Project_ConsumersAndProfessionals_PDP_CurrentSelection"
        )
    };

    let existingHero = activeProductData?.heroselectionsIdsDisplayName?.find((e) => {
        return e.split("|")[0] === activeConfigurationSKU;
    }); 

    if (activeProductData?.modelDefinitionName || activeProductData?.configurationTypes) {
        return <p className="current-selection">
            {!!activeProductData?.modelDefinitionName && <>
                <strong>{texts.model}: </strong>
                <span>{activeProductData.modelDefinitionName}</span>
                {activeProductHeroDisplayName && <span> - {activeProductHeroDisplayName}</span>}
                <br />
            </>}
            {activeProductData?.configurationTypes && activeProductData.materials && activeProductData.configurationTypes.map((type, index) => {
                let activeMaterial = activeProductData.materials[index]?.activeMaterial;
                let materialDisplayText = "";
                if (activeMaterial?.primaryMaterialSetLabel) {
                    materialDisplayText += activeMaterial?.primaryMaterialSetLabel + " / ";
                }
                if (activeMaterial?.materialLabel) {
                    materialDisplayText += activeMaterial?.materialLabel;
                }
                if (activeMaterial?.materialDisplayCode) {
                    materialDisplayText += " (" + activeMaterial?.materialDisplayCode + ")";
                }
                return (<Fragment key={`currentSelectionConfigurationType${index}`}>
                    <strong>{type}: </strong>
                    <span>{materialDisplayText}</span>
                    <br />
                </Fragment>)
            })}
            {activeProductData?.optionTypes && activeProductData?.selectedOptions && activeProductData.optionTypes.map((type, index) => {          
                let optionTypeParts = type.split('|');
                let option = activeProductData.selectedOptions[index].split('|');
                let optionDisplayText = option[0];
                let isSelectable = activeProductData.optionTypesIsUserSelectable[index]?.split('|')[0] === "True";
                
                return isSelectable ? <Fragment key={`currentSelectionOptionType${index}`}>
                    <strong>{optionTypeParts[0]}: </strong>
                    <span>{optionDisplayText}</span>
                    <br />
                </Fragment> : <></>;
            })}
        </p>
    }
    return <></>;
}

export default PDPCurrentConfigurationInfo;
